import { MarkdownSerializer as MarkdownSerializerBase } from 'prosemirror-markdown';
import { blockquote, code_block, heading, horizontal_rule, bullet_list, ordered_list, list_item, paragraph, image, hard_break, text, em, strike, strong, link, code } from './serializer';
export var ArticleMarkdownSerializer = new MarkdownSerializerBase({
  blockquote: blockquote,
  code_block: code_block,
  heading: heading,
  horizontal_rule: horizontal_rule,
  bullet_list: bullet_list,
  ordered_list: ordered_list,
  list_item: list_item,
  paragraph: paragraph,
  image: image,
  hard_break: hard_break,
  text: text
}, {
  em: em,
  strike: strike,
  strong: strong,
  link: link,
  code: code
});